import { Event } from '@models/Event'
import {
  eventsCollectionIsDynamic,
  EventsCollection as EventsCollectionModel,
} from '@models/EventsCollection'
import { DndGrid } from '@pages/venues/detail/tabs/DndGrid'
import {
  fetchEventsCollections,
  reorderEventsCollection,
  updateEventsCollection,
} from '@services/membership/EventsCollectionService'
import { useAppDispatch, useAppSelector } from '@store/hooks'
import {
  getEventsCollections,
  selectEventsCollections,
} from '@store/membership/EventsCollectionReducer'
import { initialQuery, TableParams } from '@supplement-bacon/sb-table-filters'
import { useSBRM } from '@supplement-bacon/sbrm-react'
import { Card, Empty, Flex } from 'antd'
import { useEffect } from 'react'
import EventsCollection from './EventsCollection'

const EventsCollectionCardList = () => {
  const dispatch = useAppDispatch()
  const eventCollections = useAppSelector(selectEventsCollections())
  const { isOpen } = useSBRM()

  const query: TableParams = {
    ...initialQuery,
    columnKey: 'order',
    order: 'ascend',
    pagination: { ...initialQuery.pagination, pageSize: 1000 },
  }

  useEffect(() => {
    if (isOpen) return
    dispatch(getEventsCollections(query))
  }, [isOpen])

  useEffect(() => {
    dispatch(getEventsCollections(query))
  }, [])

  return (
    <>
      <DndGrid<EventsCollectionModel>
        items={eventCollections}
        styles={{
          idle: { cursor: 'move' },
          dragging: { opacity: 0.4 },
          over: { opacity: 0.4 },
        }}
        onItemsChange={(updatedNested) => {
          const nextOrderData = updatedNested.map((m, i) => ({
            id: m.id,
            order: i,
          }))
          reorderEventsCollection(nextOrderData).then((_) =>
            dispatch(getEventsCollections(query))
          )
        }}
        renderItem={(item, style, ref) => (
          <Card
            ref={ref}
            style={{ ...style, overflow: 'hidden' }}
            key={item.id}
            title={<EventsCollection.Header id={item.id} />}
          >
            <Flex style={{ width: '100%', overflow: 'scroll' }}>
              <EventsCollection.Collection
                ids={item.events}
                displayMode={item.displayMode}
                dynamic={eventsCollectionIsDynamic(item)}
                onUpdate={(items) => {
                  updateEventsCollection({
                    ...item,
                    events: items.map((item: Event) => item.id),
                  }).then((_) => fetchEventsCollections(initialQuery))
                }}
              />
            </Flex>
          </Card>
        )}
      />
      {eventCollections.length == 0 && (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={'No collection to display'}
        />
      )}
    </>
  )
}

type EventsCollectionCardListType = {
  Card: typeof EventsCollectionCardList
}

export { EventsCollectionCardList, type EventsCollectionCardListType }
